import '../App.css';
import ProjectTile from '../components/ProjectTile';
import { Link } from 'react-router-dom';

const Work = ( {projects} ) => {

    return(
        <div className='tabs-border'>
            <div className='work-flex'>
                { projects.length && projects.map((item, index) => (
                    <Link to={'/' + item.dir} state={item}  key={index}>
                    <ProjectTile img={item.pictures[0]} dir={item.dir} text={item.title}/>
                    </Link>
                ))}
            </div>
        </div>
    )
}

export default Work;